import { type Query, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

const TEAM_QUERIES = new Set(["listTeams", "getTeam", "getCurrentUserInfo"]);
const isTeamQuery = (query: Query) => TEAM_QUERIES.has((query.queryKey[0] as { _id?: string } | undefined)?._id ?? "");

/**
 * Refresh everything that shows teams after a change: team lists (every access picker uses one), team pages, and
 * /auth/me, which holds each person's memberships and team roles.
 */
export function useRefreshTeams(): () => Promise<void> {
  const queryClient = useQueryClient();
  return useCallback(() => queryClient.invalidateQueries({ predicate: isTeamQuery }), [queryClient]);
}
